import { WorksheetBalanceFieldSet } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import React from 'react';
import { Field, NumericInput, TextOutput } from '../../../../../Core';
import { NamePrefixModifier, withInjectedProps } from '../../../../../Core/InjectedPropsContext';
import { ListFieldSection } from '../../../../../Layout';

let InitialSeparationPredriedSection: React.FC<IWorksheetComponent> = () => {
  return (
    <>
      <ListFieldSection>
        <Field input={<TextOutput />} name="Masses.DryMass" label="Specimen Total Dry Mass" />
        <NamePrefixModifier appendNamePrefix="Separation">
          <WorksheetBalanceFieldSet
            name="CoarsePortion.Masses.MassMeasurement.Equipment.Balance"
            copyTo={[
              'CoarsePortion.Masses.MassMeasurement.Equipment.DryMassBalance',
              'FinePortion.Masses.MassMeasurement.Equipment.Balance',
              'FinePortion.Masses.MassMeasurement.Equipment.DryMassBalance',
              'FinePortion.Subspecimen.Masses.MassMeasurement.Equipment.Balance',
              'FinePortion.Subspecimen.Masses.MassMeasurement.Equipment.DryMassBalance',
            ]}
          />
        </NamePrefixModifier>

        {/* We use modified labels / message paths for the Coarse Portion and Fine Portion masses
            because tare mass is not used */}
        <NamePrefixModifier appendNamePrefix="Separation.CoarsePortion.Masses">
          <Field
            input={<NumericInput />}
            name="MassMeasurement.TareAndDryMass"
            additionalMessagePaths={['MassMeasurement.DryMass', 'DryMass']}
            label="Coarse Portion Dry Mass"
          />
        </NamePrefixModifier>
        <NamePrefixModifier appendNamePrefix="Separation.FinePortion.Masses">
          <Field input={<TextOutput />} name="DryMass" />
        </NamePrefixModifier>
      </ListFieldSection>

      <ListFieldSection heading="Fine Portion Subspecimen Mass">
        <NamePrefixModifier appendNamePrefix="Separation.FinePortion.Subspecimen.Masses">
          <Field input={<NumericInput />} name="MassMeasurement.TareMass" />
          <Field input={<NumericInput />} name="MassMeasurement.TareAndDryMass" />
          <Field input={<TextOutput />} name="DryMass" />
        </NamePrefixModifier>
      </ListFieldSection>
    </>
  );
};

InitialSeparationPredriedSection = withInjectedProps(InitialSeparationPredriedSection);

export { InitialSeparationPredriedSection };
export default InitialSeparationPredriedSection;
